import React from "react";
import { StickyCta } from "./StepIntro";
import { Input } from "../ui/input";
import { Checkbox } from "../ui/checkbox";
import { Mail } from "lucide-react";

// RFC 5321-lite — good enough client-side; server uses pydantic EmailStr.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function StepEmailGate({
    email,
    marketingOptIn,
    onEmailChange,
    onOptInChange,
    onNext,
    submitting,
    error,
}) {
    const emailOk = EMAIL_RE.test(email.trim());

    return (
        <div className="pb-28" data-testid="step-email-gate">
            <div className="mt-2 space-y-3">
                <span className="eyebrow">Almost there</span>
                <h1 className="font-display text-[1.9rem] font-medium leading-tight text-meow-charcoal">
                    Where should we send the report?
                </h1>
                <p className="text-[14px] leading-relaxed text-meow-muted">
                    We&apos;ll email you your report so you can refer back to it — and
                    you can create a MeowMD account with the same email later to
                    keep tracking your cat&apos;s health.
                </p>
            </div>

            <div className="mt-6 space-y-4">
                <div>
                    <label
                        htmlFor="lead-email"
                        className="mb-1.5 block text-[13px] font-medium text-meow-charcoal"
                    >
                        Email
                    </label>
                    <div className="relative">
                        <Mail
                            className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-meow-muted"
                            strokeWidth={2}
                            aria-hidden
                        />
                        <Input
                            id="lead-email"
                            type="email"
                            inputMode="email"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => onEmailChange(e.target.value)}
                            placeholder="you@example.com"
                            className="h-14 rounded-xl border-transparent bg-white pl-11 text-base focus-visible:border-meow-teal focus-visible:ring-2 focus-visible:ring-meow-teal/20"
                            data-testid="lead-email-input"
                        />
                    </div>
                </div>

                <label
                    htmlFor="lead-marketing"
                    className={
                        "flex cursor-pointer items-start gap-3 rounded-2xl border p-4 transition-colors " +
                        (marketingOptIn
                            ? "border-meow-teal bg-[#F4FAF9]"
                            : "border-transparent bg-white shadow-[0_8px_30px_rgba(42,42,42,0.04)]")
                    }
                >
                    <Checkbox
                        id="lead-marketing"
                        checked={marketingOptIn}
                        onCheckedChange={(v) => onOptInChange(!!v)}
                        className="mt-1 h-5 w-5 border-black/20 data-[state=checked]:border-meow-teal data-[state=checked]:bg-meow-teal"
                        data-testid="lead-marketing-checkbox"
                    />
                    <div>
                        <div className="font-display text-[15px] font-medium text-meow-charcoal">
                            Send me MeowMD tips & product updates
                        </div>
                        <p className="mt-1 text-[13px] leading-relaxed text-meow-muted">
                            Optional. Occasional emails, no spam. Unsubscribe any time.
                        </p>
                    </div>
                </label>

                {error && (
                    <p
                        className="rounded-xl bg-meow-emergency px-3 py-2 text-[13px] leading-snug text-meow-red"
                        data-testid="email-error"
                    >
                        {error}
                    </p>
                )}

                <p className="text-[12px] leading-relaxed text-meow-muted">
                    Your report is private. We use your email only to send you the
                    report and, if you opt in above, to share MeowMD updates.
                </p>
            </div>

            <StickyCta>
                <button
                    type="button"
                    className="meow-btn-primary w-full"
                    onClick={onNext}
                    disabled={!emailOk || submitting}
                    data-testid="email-continue-btn"
                >
                    {submitting ? "Preparing your report…" : "Generate my report"}
                </button>
            </StickyCta>
        </div>
    );
}
